<bazis-button fill="outline" (click)="openModal()">
    <bazis-icon slot="icon-only" name="resize"></bazis-icon>
</bazis-button>
